import api from '../index'

export interface HistoryItem {
  id: number
  conversation_no: string
  user_id: number
  user: null | { nickname: string, avatar: string }
  status: string
  created_at: string | null
  last_message_at: string | null
  rating: number | null
  reception: null | { id: number, status: string, skill_group_id: number, main_agent_id: number, queued_at: string | null, started_at: string | null, closed_at: string | null, close_reason: string }
}

export interface ReplayData {
  conversation: { id: number, conversation_no: string, status: string, user_id: number }
  user: null | { id: number, nickname: string, avatar: string }
  reception: Record<string, unknown> | null
  messages: Array<{ id: number, sequence: number, sender_type: string, sender_id: number, message_type: string, content: Record<string, any>, status: string, created_at: string | null }>
  events: Array<{ id: number, event_type: string, from_agent_id: number | null, to_agent_id: number | null, metadata: Record<string, any> | null, created_at: string | null }>
  tags: Array<{ id: number, name: string, color: string }>
  internal_notes: Array<{ id: number, admin_id: number, admin_name: string, content: string, created_at: string | null }>
}

export function historyPage(params: Record<string, unknown>) {
  return api.get<unknown, { data: { list: HistoryItem[], total: number } }>('/admin/service/conversation/history/list', { params })
}

export function historyDetail(id: number) {
  return api.get<unknown, { data: ReplayData }>(`/admin/service/conversation/history/${id}`)
}
